import { __assign } from 'tslib';
import * as React from 'react';

var MediumBubbleShape = function (props) {
    return (React.createElement("svg", __assign({ height: "100%", id: "mediumBubbleShape", width: "100%", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M69.764 61.272C33.304 117.606.328 79.991.191 57.422.028 30.785 9.407 13.256 32.531 3.727c23.327-9.616 74.92-.682 37.234 57.545z", fill: "#000", fillRule: "evenodd", opacity: 0.44 })));
};

export { MediumBubbleShape as default };
//# sourceMappingURL=MediumBubbleShape.esm.js.map
